import { Database } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const DatabaseIcon = createLucideIcon(Database);
